import styled from 'styled-components';

export const Wrapper = styled.div`
    margin-top: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    p {
        text-align: center;
    }
`;
